export const dateTimeFormats = {
	short: {
		month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	medium: {
		year: 'numeric', month: 'short', day: 'numeric'
	},
	long: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	full: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
	}
};
export const messages = {
    "login.form.title": "Anmelden",
    "login.form.hint.user": "Anmeldename",
    "login.form.hint.password": "Kennwort",
    "login.form.checkbox.remember-me": "Erinnern Sie mich",
    "login.form.button.sign-in": "Anmelden",
    "login.form.message.invalid-user-credentials": "Der Anmeldename oder das Kennwort ist falsch",
    "login.form.message.account-temporarily-locked": "Ihr Konto ist vorübergehend gesperrt. Versuchen Sie es in 5 Minuten erneut.",
    "login.form.message.user-required": "Geben Sie einen Anmeldenamen ein",
    "login.form.message.password-required": "Geben Sie ein Kennwort ein",
    "login.form.button.forgot-password": "Kennwort vergessen?",
    "error.mfa-required.title": "2FA einrichten",
    "error.mfa-required.message1": "Zum Schutz Ihres Kontos ist eine Zwei-Faktor-Authentifizierung (2FA) erforderlich.",
    "error.mfa-required.message2": "Sie werden zu Ihren Kontoeinstellungen im Online Dashboard weitergeleitet. Aktivieren Sie dort die Zwei-Faktor-Authentifizierung (2FA), befolgen Sie die Anweisungen zur Einrichtung und kehren Sie anschließend hierher zurück.",
    "error.mfa-required.learnMore": "Weitere Informationen zur 2FA",
    "error.mfa-required.continue": "Weiter",
    "error.root-admin-login.title": "Fehler 403 – verboten",
    "error.root-admin-login.message": "Sie sind als Nur-Lesen-Administrator angemeldet. Um auf die Web Recovery-Konsole zugreifen zu können, müssen Sie sich als Benutzer oder Administrator eines Kunden-Mandanten anmelden.",
    "error.server-busy.message": "Der Server ist beschäftigt. Versuchen Sie es später erneut.",
    "error.network-connection.title": "Netzwerkverbindungsfehler",
    "error.network-connection.message": "Überprüfen Sie Ihre Internetverbindung und versuchen Sie es dann erneut.",
    "error.internal-server-error.title": "Interner Server-Fehler",
    "error.internal-server-error.message": "Kontaktieren Sie den Support, um den Fehler zu beheben, und geben Sie die Fehlerdetails an:",
    "error.internal-server-error.copy.button": "Kopieren"
};
